<template>
	<div id="modal-orders-sales-orders-set-discount">
		<b-modal :id="modalName" title="Set Discount: " scrollable hide-footer size="sm" @shown="resetAndFocus">
            <template v-slot:modal-title>
                Set Discount:
            </template>

            <b-form @submit.stop.prevent="setDiscount">
                <b-form-group
                    id="input-group-discount"
                    label="Discount:"
                    label-for="input-discount"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-discount"
                        v-model="discount"
                        type="number"
                        placeholder="0"
                        size="sm"
                        autocomplete="off"
                        ref="setdiscountinput"
                        @focus.native="$event.target.select()"
                    >
                    </b-form-input>
                </b-form-group>
                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [

		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-orders-sales-orders-set-discount',
                discount: 0,
                submitting: 0
			}
		},

		methods: {
            setDiscount() {
                const discountValue = this.discount !== '' && this.discount !== null && this.discount !== undefined ? Number(this.discount) : 0
                this.$emit('setDiscount', discountValue)
                this.closeModal(this.modalName)
            },

            resetAndFocus() {
                this.discount = 0
                this.$nextTick(() => {
                    this.$refs.setdiscountinput.focus()
                })
            },

            focusInput() {
                this.$refs.setdiscountinput.focus()
            }
		},

		computed: {

        },


		mounted() {

        }
	}
</script>
<style lang="scss">
    #modal-sales-orders-set-discount {
        .modal-dialog {
            width: 190px !important;
        }

        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
